<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	height="100%"
	fill="currentColor"
	version="1.1"
	viewBox="0 0 36 36"
	width="100%"
	class={classes('w-12 h-12 ', additionalClass)}
	><use xlink:href="#ytp-id-50" /><path
		d="M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z"
	/></svg
>
